import { useEffect } from 'react';

import { trackEvent } from '@intercom/messenger-js-sdk';

export const useIntercomComponentOnOpenEventTrack = (eventName, metadata = {}) => {
  useEffect(() => {
    trackEvent(eventName, metadata);
  }, []);
};
